import React, { useContext, useEffect } from 'react';
import AlreadyRegisteredMailLayout from './already-registered-mail-layout';
import obfuscatorEmail from 'obfuscator-email';
import Loading from 'components/loading';
import { useNavigation } from 'hooks/index';
import { LoanApplicationContext } from 'containers/context/useGetLoanApplication';
import { useGetLoanQuery } from 'generated/graphql';

const AlreadyRegisteredMail: React.FC = () => {
    const { goToWelcome } = useNavigation();
    const { loanApplicationId } = useContext(LoanApplicationContext);

    const {  data: { loanApplication }, loading, refetch } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });

    useEffect(() => {
        if(!loanApplicationId) {
            return null;
        }
    },[loanApplicationId])

    useEffect(() => {
        refetch();
    }, []);

    if (loading) {
        return <Loading />;
    }

    return (
        <AlreadyRegisteredMailLayout
            onSubmit={goToWelcome}
            email={obfuscatorEmail(loanApplication.borrower.email)}
        />
    );
};

export default AlreadyRegisteredMail;
